var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52058 1.55319C9.98624 0.120037 12.0138 0.120039 12.4794 1.55319L13.794 5.5989C14.0022 6.23982 14.5995 6.67376 15.2734 6.67376H19.5273C21.0342 6.67376 21.6607 8.60205 20.4416 9.48779L17.0001 11.9882C16.4549 12.3843 16.2268 13.0864 16.435 13.7273L17.7496 17.7731C18.2152 19.2062 16.5749 20.3979 15.3558 19.5122L11.9143 17.0118C11.3691 16.6157 10.6309 16.6157 10.0857 17.0118L6.64418 19.5122C5.42507 20.3979 3.78477 19.2062 4.25043 17.773L5.56496 13.7273C5.77321 13.0864 5.54507 12.3843 4.99987 11.9882L1.55838 9.48779C0.339272 8.60205 0.965811 6.67376 2.47271 6.67376H6.72663C7.40054 6.67376 7.9978 6.23982 8.20605 5.5989L9.52058 1.55319Z",
    fill: "#F7CB15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.dfa71083086edabbb5d08b4430b67a7a.svg";
export { ForwardRef as ReactComponent };